import React, { useEffect } from 'react'
import useMakeRequest from '../utils/ApiHelper'
import { ApiConstants } from '../constants/ApiConstants'
import FrontLoader from '../component/layout/FrontLoader'
import { formatDateTime, getDate, getDateTime } from '../utils/Helper'
import { useNavigate } from "react-router-dom";
import { LanguageConstants } from '../constants/LanguageConstants'

function MessageHistoryModal(props:any) {
const quotationHistory = useMakeRequest()
const navigate = useNavigate()

useEffect(()=>{
  if(props){
    const payload ={
        quotation_id: props?.data?.quotation_id
    }
    quotationHistory.makeRequest({payload, url: ApiConstants?.QuotesMessageHistory, toastStatus: false })
  }
},[props])

  return (
    <>
    {quotationHistory.loading ? <FrontLoader/> : null}
     <div className="modal fade com-modal modal view-message-history-modal show" id="viewMessageHistoryModal" aria-labelledby="viewMessageHistoryModalLabel" aria-hidden="false" style={{ display: 'block' }} >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="viewMessageHistoryModalLabel">{LanguageConstants?.ORDERQUOTATIONID} :- {props?.data?.quotation_id}</h5>
                            <button type="button" onClick={()=>props?.setHistoryshow(false)} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>{LanguageConstants?.Item}</th>
                                            <th className="text-center">{LanguageConstants?.PARTNAME}</th>
                                            <th className="text-center">{LanguageConstants?.MESSAGE}</th>
                                            <th className="text-center">{LanguageConstants?.BY}</th>
                                            <th className="text-center">{LanguageConstants?.DATE}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {quotationHistory?.data?.data?.map((res:any ,i:any)=>(
                                            <tr key={i}>
                                            <td className="text-center">{res?.item ? res?.item :'-'}</td>
                                            <td className="text-center">{res?.part_number ? res?.part_number : '-'}</td>
                                            <td className="text-center">{res?.message ? res?.message : 'N/A'}</td>
                                            <td className="text-center">{res?.user_type == '1' ? "Admin" : 'User'}</td>
                                            <td className="text-center">{getDate(res?.created_at)}</td>
                                        </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </>
  )
}


export default MessageHistoryModal